import { Input } from "antd";
import styled from "styled-components";

export const SearchInput = styled(Input)({
  maxWidth: 300,
});
